import React, { useEffect, useRef } from 'react';
import { cn } from '../../lib/utils';

interface CheckboxProps {
  checked: boolean;
  /** Renders the dash state for a partial selection. */
  indeterminate?: boolean;
  disabled?: boolean;
  onChange: () => void;
  className?: string;
}

/**
 * Checkbox supporting the indeterminate state.
 *
 * `indeterminate` is a DOM property with no HTML attribute, so React cannot
 * set it declaratively — hence the ref and the effect.
 */
export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  indeterminate = false,
  disabled,
  onChange,
  className,
}) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      className={cn(
        'w-4 h-4 rounded border-gray-300 dark:border-gray-600 text-primary-600',
        'focus:ring-primary-500 focus:ring-offset-0',
        'disabled:opacity-30 disabled:cursor-not-allowed',
        'cursor-pointer accent-primary-600',
        className
      )}
    />
  );
};
